import {gql} from '@apollo/client';
import {DELIVERY_TASK_ORDER_DETAIL_FIELDS, DeliveryTaskOrderType} from '../types/DeliveryTaskOrderType';
import {client} from '../../../../graphql/client';

export const GET_DELIVERY_TASK_ORDER_BY_ID = gql`
  query GetDeliveryTaskOrderById($deliveryTaskOrderId: Long!) {
    getDeliveryTaskOrderById(deliveryTaskOrderId: $deliveryTaskOrderId){
      ...DeliveryTaskOrderFields
    }
  }
  ${DELIVERY_TASK_ORDER_DETAIL_FIELDS}
`;

export interface GetDeliveryTaskOrderByIdResponse {
    getDeliveryTaskOrderById: DeliveryTaskOrderType;
}
